import {Injectable, inject} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';


import { OrganizationSiteListResponse } from '../types';


@Injectable({
    providedIn: 'root'
})
export class SiteListService {
    private readonly _http = inject(HttpClient);

    getSiteList(siteURL: string, params: HttpParams) {
    return this._http.get<OrganizationSiteListResponse>(siteURL, {
      params: params,
    });
  }
}